// @flow
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.warn(
    'In most cases cookies are not the best way to store data. Investigate whether localStorage will fit your needs instead. https://w.pinadmin.com/display/Pinterweb/Cookie+Guidelines',
  );
}

/** Get a cookie's value
 *
 *  @param string  key     The token used to create the cookie
 *  @return void
 */
export const get = (key: string) => {
  const tmp = document.cookie.match(new RegExp('\\b' + key + '=.+?($|;)', 'g'));
  if (!tmp || !tmp[0]) {
    return null;
  } else {
    return unescape(tmp[0].substring(key.length + 1, tmp[0].length).replace(';', '')) || null;
  }
};

/** Return GTM date string of "now" + time to live
 *
 *  @param integer  ttl     Time To Live (hours)
 *  @return string
 */
export const hoursToExpireDate = (ttl?: number): string => {
  if (isNaN(parseInt(ttl, 10))) {
    return '';
  } else {
    const now = new Date();
    now.setTime(Date.now() + parseInt(ttl, 10) * 60 * 60 * 1000);
    return now.toUTCString();
  }
};

/** Set a cookie
 *
 *  @param string  key     The token that will be used to retrieve the cookie
 *  @param string   value   The string to be stored
 *  @param integer  ttl     Time To Live (hours)
 *  @param string   path    Path in which the cookie is effective, default is "/" (optional)
 *  @param boolean  secure  Use SSL or not, default false (optional)
 *
 *  @return setted cookie
 */
export const set = (key: string, value: string, ttl?: number, path?: string, secure?: string) => {
  const cookie = [key + '=' + escape(value), 'path=' + (!path || path === '' ? '/' : path)];
  const hours = hoursToExpireDate(ttl);
  if (hours) {
    cookie.push('expires=' + hours);
  }
  if (secure) {
    cookie.push('secure');
  }
  document.cookie = cookie.join('; ');
  return document.cookie;
};

/** Unset a cookie
 *
 *  @param string  key     The token that will be used to retrieve the cookie
 *  @param string   path    Path used to create the cookie (optional)
 *  @return void
 */
export const unset = (key: string, path?: string) => {
  path = !path || typeof path !== 'string' ? '' : path;
  if (get(key)) {
    set(key, '', -100, path);
  }
};

/** Return true if cookie functionnalities are available
 *
 *  @return boolean
 */
export const test = () => {
  set('b49f729efde9b2578ea9f00563d06e57', 'true');
  if (get('b49f729efde9b2578ea9f00563d06e57') === 'true') {
    unset('b49f729efde9b2578ea9f00563d06e57');
    return true;
  }
  return false;
};
